import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { PAGES_PATH } from "./params";
import { useUserStore } from "../hooks/redux-hooks/user-store/user.store";

const RequireCompleteProfile = () => {
  const { isProfileComplete, hasPhone } = useUserStore();

  if (!isProfileComplete) {
    return <Navigate replace to={hasPhone ? PAGES_PATH.PROFILE_COMPLETION : PAGES_PATH.ADD_PHONE_NUMBER} />;
  }

  return <Outlet />;
};

export default RequireCompleteProfile;
